import React from "react";

const DevLog6 = React.forwardRef((props, ref) => {
  const flexStyle = {
    display: "flex",
    flexWrap: "wrap",
    width: "max-content",
    maxWidth: "100%",
    minWidth: "min(20rem, 100%)",
    alignItems: "center",
  };

  const heading = "Character Heirlooms!";
  const date = "4th April 2022";
  return (
    <div ref={ref}>
      {/* // ! Do not change positions */}
      <h1>{heading}</h1>
      <h4>{date}</h4>
      <div>
        <p>
          <strong>
            Hello everyone and welcome to our sixth Discovery Log!
          </strong>
        </p>
        <br />
        <div>
          <p>
            Previously we gave a small teaser of some mysterious, large-scale
            mechs which was going to be the topic of today’s Discovery Log.
            After sitting and discussing it with the team, we feel that the
            mechs are not quite ready to be shown off yet in full in a Discovery
            Log.
          </p>
          <br />
          <p>
            Instead, today we will be revealing and showing off the remaining
            Heirlooms as well as a number of new animations that were just added
            to the game. Let’s dive right in!
          </p>
          <br />
          <div style={flexStyle}>
            <p
              style={{
                width: "min(40rem, 100%)",
                minWidth: "min(15rem, 100%)",
                marginRight: "auto",
              }}
            >
              The first new Heirloom is the Grappling Hook which will be
              exclusively given to the Rogue. As one can expect from a Grappling
              Hook, it can be used to attach yourself to certain Grapple Points
              and swing yourself back and forth to reach areas that players
              would not be able to reach normally. The Grappling Hook has a
              minimum and maximum distance and will pull the player into its
              ideal distance whenever they want to swing from a Grappling Point.
              The Grappling Hook was put together by Prakhhar Makhija.
            </p>

            <img
              src="../logImages/log6/Grapple.png"
              alt="Grapple"
              style={{
                maxWidth: "100%",
                width: "auto",
                marginRight: "6rem",
                maxHeight: "15rem",
              }}
            />
            <br />
            <br />
            <p
              style={{
                width: "min(40rem, 100%)",
                minWidth: "min(15rem, 100%)",
                marginRight: "auto",
              }}
            >
              The very last Heirloom that will be featured in the game is the
              Javelin and will be exclusively given to the Paladin. It is a jack
              of all trades Heirloom as it can be used in a variety of
              scenarios. It can be thrown to activate certain objects that are
              normally out of reach, it can be used as a long range throwing
              weapon, and it can stick to walls after being thrown which can
              then be used as Grapple Point for the Rogue to swing from. After
              the Javelin has been thrown, you can call it back to you instantly
              by pressing the same key that you threw it with. The Javelin was
              brought to life by Christian Young.
            </p>

            <img
              src="../logImages/log6/Javelin.png"
              alt="Javelin"
              style={{
                maxWidth: "100%",
                width: "auto",
                marginRight: "9rem",
                maxHeight: "15rem",
              }}
            />
          </div>
          <br />
          <p>
            Well, that’s going to do it for this Discovery Log, thanks for
            checking it out. Before we end things off, we have now posted an
            official sizzle reel for Steelwalker on the homepage of our website!
            Please, check it out! With that, take care everyone!
          </p>
          <br />
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              flexDirection: "row",
              margin: "0 auto",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src="../logImages/log6/Patinations_Shield.gif"
              alt="Overworld Fog"
              style={{
                maxWidth: "min(100%, 40rem)",
                width: "auto",
                margin: "0 auto",
              }}
            />
            <img
              src="../logImages/log6/Patinations_Javelin.gif"
              alt="Overworld Fog"
              style={{
                maxWidth: "min(100%, 40rem)",
                width: "auto",
                margin: "0 auto",
              }}
            />
            <img
              src="../logImages/log6/Patinations_Dagger.gif"
              alt="Overworld Fog"
              style={{
                maxWidth: "min(100%, 40rem)",
                width: "auto",
                margin: "0 auto",
              }}
            />
          </div>
          <br />
          <p
          // style={{
          //   width: "min(40rem, 100%)",
          //   minWidth: "min(15rem, 100%)",
          //   marginRight: "auto",
          // }}
          >
            Well, that’s going to do it for this Discovery Log, thanks for
            checking it out. We hope to have a Discovery Log on the mechs soon
            as originally planned. Until that arrives, take care everyone!
          </p>
          <br />
          <br />- Particle Interactive
        </div>
      </div>
    </div>
  );
});

export default DevLog6;
